module.exports = __webpack_public_path__ + "media/images/common/my_nav_3-add6691296332a1b13ebf9875b1b5246.png";